module.exports = __webpack_public_path__ + "img/logomiron3.290e7e96.png";